export const users = {
      title: 'Usuarios',
      subtitle: 'Administra invitaciones reales y roles de acceso de tu organización',
      invite: 'Invitar usuario',
      emptyTitle: 'Sin accesos para mostrar',
      emptyDescription: 'No hay miembros ni invitaciones pendientes que coincidan con los filtros actuales.',
      searchPlaceholder: 'Buscar por correo, nombre o rol',
      allStatuses: 'Todos los estados',
      active: 'Activo',
      pending: 'Pendiente',
      blocked: 'Suspendido',
      owner: 'Propietario',
      admin: 'Admin',
      user: 'Usuario',
      readOnly: 'Solo lectura',
      totalVisible: 'Total visible',
      activeUsers: 'Miembros activos',
      pendingUsers: 'Invitaciones pendientes',
      adminUsers: 'Admins',
      withFilters: 'Con filtros aplicados',
      operational: 'Con acceso activo',
      requiresAction: 'Pendientes de aceptar',
      withRealAccess: 'Acceso real vigente',
      inviteTitle: 'Enviar invitación',
      inviteSubtitle: 'Crea una invitación real en el backend para que el usuario active su acceso al iniciar sesión.',
      inviteEmailHint: 'Debe coincidir con el correo que el usuario usará en Microsoft Entra ID.',
      expiresInDays: 'Vence en días',
      expiresInDaysHint: 'Número de días antes de que la invitación expire.',
      sendInvitation: 'Enviar invitación',
      pendingInvitation: 'Invitación pendiente',
      invitationReadyTitle: 'Invitación creada',
      invitationReadyDescription: 'El acceso para {{email}} ya quedó listo. Comparte este enlace para que inicie sesión.',
      copyAccessLink: 'Copiar enlace',
      copyInvitationMessage: 'Copiar mensaje',
      revokeInvitation: 'Revocar invitación',
      revokeInvitationTitle: 'Revocar invitación',
      revokeInvitationSubtitle: 'Esta acción cancelará la invitación pendiente de {{email}}.',
      revokeInvitationSubtitleFallback: 'Esta acción cancelará la invitación pendiente seleccionada.',
      revokeInvitationConfirm: 'Sí, revocar',
      copyLinkSuccess: 'Se copió el enlace de acceso.',
      copyMessageSuccess: 'Se copió el mensaje de invitación.',
      copyFailed: 'No se pudo copiar automáticamente. Intenta copiar el enlace manualmente.',
      accessState: 'Estado de acceso',
      memberActiveState: 'Acceso activo',
      memberSuspendedState: 'Acceso suspendido',
      expiresOn: 'Vence el {{date}}',
      editRoleTitle: 'Actualizar rol',
      editRoleSubtitle: 'Actualiza el rol organizacional de {{email}}.',
      editRoleSubtitleFallback: 'Actualiza el rol organizacional del usuario seleccionado.',
      suspendUserTitle: 'Suspender usuario',
      suspendUserSubtitle: 'Esta acción suspenderá el acceso activo de {{email}}.',
      suspendUserConfirm: 'Sí, suspender',
      reactivateUserTitle: 'Reactivar usuario',
      reactivateUserSubtitle: 'Esta acción reactivará el acceso de {{email}}.',
      reactivateUserConfirm: 'Sí, reactivar',
      toggleSuspensionSubtitleFallback: 'Confirma la actualización del estado de acceso de este usuario.',
      invitationMessageTemplate: 'Hola. Ya tienes acceso a Sunbrick ERP.\n\nIngresa aquí:\n{{link}}\n\nDebes iniciar sesión con este correo:\n{{email}}\n\nSi tu invitación sigue vigente, el acceso se activará automáticamente al entrar.',
    } as const;
